import { Outlet, Route, Routes } from 'react-router-dom'
import { ScrollToTop } from '@/app/ScrollToTop'
import { ConsentBanner } from '@/components/consent/ConsentBanner'
import { SiteShell } from '@/components/layout/SiteShell'
import { sitePages } from '@/config/pages'
import { BlogPage } from '@/legacy/pages/BlogPage'
import { BlogPostPage } from '@/legacy/pages/BlogPostPage'
import { ManifestoPage } from '@/legacy/pages/ManifestoPage'
import { NominationRoutePage } from '@/nominations/NominationRoutePage'
import { nominationRoutePattern } from '@/nominations/route'
import { AboutPage } from '@/pages/AboutPage'
import { FaqPage } from '@/pages/FaqPage'
import { FirstTwoMonthsPage } from '@/pages/FirstTwoMonthsPage'
import { HomePage } from '@/pages/HomePage'
import { HowItWorksPage } from '@/pages/HowItWorksPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { PrivacyPage } from '@/pages/PrivacyPage'
import { UnitEconomicsCalculatorPage } from '@/pages/UnitEconomicsCalculatorPage'

const SiteLayout = () => (
  <SiteShell>
    <Outlet />
  </SiteShell>
)

const LegacyLayout = () => (
  <SiteShell legacy>
    <Outlet />
  </SiteShell>
)

// Keep public routes explicit. Paths, and which pages are prerendered, come from src/config/pages.ts.
// The browser (main.tsx) and the prerenderer (entry-server.tsx) render the same tree around App, so
// ids from useId match on hydration.
export const App = () => (
  <>
    <ScrollToTop />
    <Routes>
      {/* Nomination pages (src/nominations) are a standalone product: no header, footer, or nav. */}
      <Route path={nominationRoutePattern} element={<NominationRoutePage />} />

      <Route element={<SiteLayout />}>
        <Route path={sitePages.home.path} element={<HomePage />} />
        <Route path={sitePages.howItWorks.path} element={<HowItWorksPage />} />
        <Route path={sitePages.about.path} element={<AboutPage />} />
        <Route path={sitePages.faq.path} element={<FaqPage />} />
        <Route path={sitePages.privacy.path} element={<PrivacyPage />} />
        {/* Unlisted, share-by-link-only pages: noindex, no sitemap entry, never linked. */}
        <Route path={sitePages.firstTwoMonths.path} element={<FirstTwoMonthsPage />} />
        <Route path={sitePages.unitEconomics.path} element={<UnitEconomicsCalculatorPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      {/* Old pages kept until they are modernised or removed: see src/legacy/README.md. Nothing in the
          nav or on the home page links to the blog. */}
      <Route element={<LegacyLayout />}>
        <Route path={sitePages.manifesto.path} element={<ManifestoPage />} />
        <Route path={sitePages.blog.path} element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
      </Route>
    </Routes>
    <ConsentBanner />
  </>
)
